import type { HDStethEcgTransport } from './ecg-stream'

/** Bind ECG reception to the same source peer used for the consultation audio. */
export function createPeerEcgTransport(
  sourcePeerId: string,
  send: (message: unknown) => void,
  subscribe: (listener: (peerId: string, message: unknown) => void) => () => void,
): HDStethEcgTransport {
  return { send, subscribe: (listener) => subscribe((peerId, message) => { if (peerId === sourcePeerId) listener(message) }) }
}
